// Bitmask helpers for working days: Mon..Sun => bits 0..6
export const isDayEnabled = (mask: number, index: number): boolean => {
  if (!Number.isFinite(mask)) return false;
  return ((mask >> index) & 1) === 1;
};

export const setDay = (mask: number, index: number, on: boolean): number => {
  if (on) {
    return mask | (1 << index);
  } else {
    return mask & ~(1 << index);
  }
};

export const toggleDay = (mask: number, index: number): number => setDay(mask, index, !isDayEnabled(mask, index));

export const parseTimeHHmm = (s?: string | null): { h: number; m: number } | null => {
  if (!s) return null;
  const m = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(s.trim());
  if (!m) return null;
  return { h: parseInt(m[1], 10), m: parseInt(m[2], 10) };
};

export const isValidWindow = (start?: string | null, end?: string | null): boolean => {
  const a = parseTimeHHmm(start);
  const b = parseTimeHHmm(end);
  if (!a || !b) return false;
  if (a.h < b.h) return true;
  if (a.h > b.h) return false;
  return a.m < b.m;
};
